import { createTheme } from '@mui/material/styles';
import { breakpoints } from '@/common/styles/breakpoints';
import { palette } from '@/common/styles/palette';
import { themeComponents } from '@/common/styles/theme-components';
import { typography } from '@/common/styles/typography';

const muiTheme = createTheme({
  typography,
  palette,
  breakpoints,
  spacing: 4,
  shape: {
    borderRadius: 8,
  },
  components: themeComponents,
});

export default muiTheme;
